export const MENU_SLUG = {
  login: "login",
  sign_up: "sign-up",
  forgot_password: "forgot-password",
  my_cars: "my-cars",
  profile: "profile",
  snapshot: "snapshot",
  service_history: "service-history",
  track: "track",
  reports: "reports",
  utilities: "utilities",
  set_up_consumables: "set-up-consumables",
  tutorials: "tutorials",
  faq: "faq",
  contact_us: "contact-us",
  checklist: "checklist",
  payments: "payments",
  billing: "billing",
};
